export default "__VITE_ASSET__CEMxNWbj__"